import { Component } from '@angular/core';

@Component({
  selector: 'app-nested-blockquotes-demo',
  templateUrl: './nested-blockquotes-demo.component.html',
})
export class NestedBlockquotesDemoComponent {}
